import React from 'react';
import { Space, Button } from 'antd';
import * as Styled from './styled';

interface Props {
  onClick?: () => void;
  title?: string;
  message?: string;
}
export const Retry = (props: Props) => {
  return (
    <Styled.Container>
      <Space direction="vertical" align="center">
        <Button type="primary" ghost onClick={() => props.onClick?.()}>{ props.title || 'Retry'}</Button>
        <Styled.RetryMessage>{ props.title || 'Please try again'}</Styled.RetryMessage>
      </Space>
  </Styled.Container>
  );
}
